import { Component, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';


/**
 * Component for modal use.....
 * Inputs :
 * visible => boolean to determine to show the modal or not
 * size => determine the size of the modal, single or double.
 * showFooter => Boolean to determine to show a customer-site-customer-site-footer-editor or not
 * ex : <modal [visible]="true" (close)="function()" [size]="single" [showFooter] = "false">Content</modal>
 * @class
 */
@Component({
  selector: 'modal',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./modal.component.scss'],
  templateUrl: './modal.component.html',
})

export class ModalComponent {
  // input for showing modal
  @Input() visible: boolean = false;
  // input for size of the modal
  @Input() size: string = 'single';
  // input to show a customer-site-customer-site-footer-editor on the modal or not
  @Input() showFooter: boolean = true;
  // output to trigger a close
  @Output() close: EventEmitter<any> = new EventEmitter();


  /**
   * Emit the close action to the host
   */
  closeAction() {
    this.close.emit(true);
  }
}
